import Chip from "@mui/material/Chip";
import { useTranslation } from "react-i18next";

import type { EventState } from "~/types/events-admin";

const COLOR: Record<
  EventState,
  "default" | "primary" | "error" | "success" | "info"
> = {
  upcoming: "default",
  soon: "primary",
  live: "error",
  ended: "default",
  recording: "success",
};

/** The derived webinar state, as the list and the editor both show it. */
export function EventStateChip({ state }: { state: EventState }) {
  const { t } = useTranslation();
  return (
    <Chip
      label={t(`events.state.${state}`)}
      color={COLOR[state]}
      variant={state === "live" ? "filled" : "outlined"}
      size="small"
      data-testid={`event.state-${state}`}
    />
  );
}
